import { HomeSectionViewMode } from 'constants/homeSectionViewMode';

export const HOME_VIEW_MODE_CHANGE_EVENT = 'homeViewModeChange';

export interface HomeViewModeChangeEventDetail {
  mode: HomeSectionViewMode;
}

export const dispatchHomeViewModeChange = (mode: HomeSectionViewMode) => {
  const event = new CustomEvent<HomeViewModeChangeEventDetail>(HOME_VIEW_MODE_CHANGE_EVENT, {
    detail: { mode },
  });
  window.dispatchEvent(event);
};

export const addHomeViewModeChangeListener = (callback: (detail: HomeViewModeChangeEventDetail) => void) => {
  const listener = (event: Event) => {
    const customEvent = event as CustomEvent<HomeViewModeChangeEventDetail>;
    callback(customEvent.detail);
  };
  window.addEventListener(HOME_VIEW_MODE_CHANGE_EVENT, listener);
  return () => window.removeEventListener(HOME_VIEW_MODE_CHANGE_EVENT, listener);
};
